import type {
  DataProvider,
  GetListParams,
  GetListResult,
  GetManyParams,
  GetManyReferenceParams,
  GetManyReferenceResult,
  GetManyResult,
  GetOneParams,
  GetOneResult,
} from "react-admin";
import {
  backendListResponseToRAGetListResult,
  getAuthenticatedBackendClient,
  reactAdminToDRFPagination,
} from "../api/backend.api";
import { ManualRefund } from "../generated/backendClient";
import { AbstractDataProvider } from "./AbstractDataProvider";
import { z } from "zod";

const listFilterZod = z.object({
  drivingSchoolId: z.string().optional(),
});

export class ManualRefundProvider extends AbstractDataProvider<ManualRefund> {
  async getOne(resource: string, { id }: GetOneParams): Promise<GetOneResult<ManualRefund>> {
    const backendClient = await getAuthenticatedBackendClient();
    const manualRefund = await backendClient.manualRefund.manualRefundRetrieve({ id });
    return { data: manualRefund };
  }

  async getMany(resource: string, { ids }: GetManyParams): Promise<GetManyResult<ManualRefund>> {
    const data: Array<ManualRefund> = [];
    for (const id of ids) {
      const { data: record } = await this.getOne(resource, { id });
      data.push(record);
    }
    return { data };
  }

  async getList(resource: string, { pagination, filter }: GetListParams): Promise<GetListResult<ManualRefund>> {
    const parsedListFilter = listFilterZod.parse(filter);
    const backendClient = await getAuthenticatedBackendClient();
    const response = await backendClient.manualRefund.manualRefundList({
      ...reactAdminToDRFPagination(pagination),
      ...parsedListFilter,
    });
    return backendListResponseToRAGetListResult(response);
  }

  async getManyReference(
    resource: string,
    { filter, sort, pagination }: GetManyReferenceParams,
  ): Promise<GetManyReferenceResult<ManualRefund>> {
    return this.getList(resource, { filter, sort, pagination });
  }
}

export const maunalRefundProvider = new ManualRefundProvider() as DataProvider;
